<template>
  <v-select
    v-bind="[fieldProps, $attrs]"
    :loading="loading"
    :items="items"
    v-model="model"
    name="finalidade"
    :menu-props="menuProps"
    placeholder="Finalidade"
  ></v-select>
</template>

<script>
import { mixin } from "./mixin";

const _config = {
  mod: "finalities",
};

const _data = {
  loading: true,
  model: null,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    menuProps() {
      const height = window.innerHeight - 200;

      return {
        maxHeight: height,
        closeOnContentClick: true,
      };
    },
  },
  watch: {
    $route(v) {
      if (["/imoveis", "/locacao"].includes(v.path))
        this.model = v.path === "/imoveis" ? "Venda" : "Aluguel";
      else if (["/rural"].includes(v.path) && v.query.finalidade)
        this.model = v.query.finalidade;
      else this.model = null;
    },
    model(v) {
      const path = v === "Venda" ? "/imoveis" : "/locacao";
      if (
        ["/imoveis", "/locacao"].includes(this.$route.path) &&
        this.$route.path !== path
      ) {
        this.$router.push({ path });
      }
    },
  },
  mounted() {
    if (["/imoveis", "/locacao"].includes(this.$route.path))
      this.model = this.$route.path === "/imoveis" ? "Venda" : "Aluguel";
    else if (
      ["/rural"].includes(this.$route.path) &&
      this.$route.query.finalidade
    )
      this.model = this.$route.query.finalidade;
  },
  created() {
    this.$rest(_config.mod)
      .get()
      .finally(() => (this.loading = false));
  },
  mixins: [mixin],
};
</script>
